import { axiosPost } from "./AxiosHelper";
import {
  decryptedText,
  encryptedText,
  getAllLocations,
  getAllOrganizations,
  getAllQuestionCategory,
  getAllResponseTypes,
  getAllUserClassifications,
  getAllUserDepartments,
  getAllUserDesignations,
  getSurveyAssignmentsWithoutPublic,
} from "./ApiUrl";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import {
  QueryClient,
  useQuery,
  useQueryClient,
} from "react-query";
import { ToastTypeCode,  showToast, ToastPosition, RoleTypeCode } from "./Constant";

export let PageRecordLimit: number =
  Number(localStorage.getItem("PageRecordLimit")) || 10;

export const setPageRecordLimit = (newLimit: number) => {
  PageRecordLimit = newLimit;
  localStorage.setItem("PageRecordLimit", newLimit.toString());
};

export const DateFormatCommon = "dd/MM/yyyy";

const encrypt = async (text: any) => {
  const response: any = await axiosPost(encryptedText, {
    plainText: text,
  });

  return response?.data.ExtraData;
};

export const formatDateToDDMMStringYY = (dateString?: string | null): string => {
  if (!dateString) return "";

  return new Date(dateString)
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
};

export const particularOrganization= -1;

const decrypt = async (text: any) => {
  const response: any = await axiosPost(decryptedText, {
    encryptText: text,
  });

  return response?.data.ExtraData;
};

export const getCurrentDate = (): string => {
  const now = new Date();
  return now.toISOString();
};

export const getCurrentDateReturningObject = (): Date => {
  return new Date();
};

export const convertToUTC = (date: any): string => {
  const parsedDate = typeof date === "string" ? new Date(date) : date;
  return parsedDate.toISOString();
};

export const fetchOrganization = async (): Promise<Option[]> => {
  try {
    const response: any = await axiosPost(getAllOrganizations, {
      SearchText: "",
      IsActive: true,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "ASC",
      SortBy: "OrganizationId",
    });

    const data = response.data.ExtraData || [];
    const options = data?.map((item: any) => ({
      label: item.OrganizationName,
      value: item.OrganizationId,
    }));
    return options;
  } catch (error) {
    return [];
  }
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      showToast("Text copied to clipboard", ToastTypeCode?.SUCCESS);
    })
    .catch((err) => {
      showToast("Error in copying text: ", ToastTypeCode?.ERROR);
    });
};

export const fetchSurveyAssignments = async (
  appContextdata: any,
  Formtype: any
): Promise<any[]> => {
  try {
    const response: any = await axiosPost("/Dashboard/GetSurveyAssignments", {
      OrganizationId: appContextdata?.OrganizationId,
      FormType: Formtype,
      SortDir: 'DESC'
    });

    const data = response?.data?.ExtraData || [];

    return data;
  } catch (error) {
    return [];
  }
};

export const fetchSurveyAssignmentswithoutPublic = async (
  appContextdata: any,
  Formtype: number
): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getSurveyAssignmentsWithoutPublic, {
      OrganizationId: appContextdata?.OrganizationId,
      FormType: Formtype,
      SortDir: 'DESC'
    });

    const data = response?.data?.ExtraData || [];

    return data;
  } catch (error) {
    return [];
  }
};

export { encrypt, decrypt };

export interface Option {
  label: string;
  value: number;
}
export interface Organization {
  OrganizationId: number;
  OrganizationName: string;
}
export const checkIfSuperAdmin = (appContextdata: any) => {
  const role = appContextdata?.Role;
  return role === RoleTypeCode?.SuperAdmin;
};
export const IsAdmin = (appContextdata: any) => {
  const role = appContextdata?.Role;
  return role === RoleTypeCode?.Administrator;
};

export const backgroundColors = [
  "#4169E1",
  "#E1C16E",
  "#36454F",
  "#9F2B68",
  "#FFBF00",
  "#7FFFD4",
  "#CBC3E3",
  "#87CEEB",
  "#CD7F32",
  "#899499",
  "#454B1B",
  "#F2D2BD",
  "#DE3163",
  "#F5F5DC",
  "#008080",
  "#A52A2A",
  "#FFFAA0",
  "#AFE1AF",
  "#E97451",
  "#C9A9A6",
  "#A95C68",
  "#4682B4",
  "#C19A6B",
  "#8A9A5B",
  "#023020",
  "#FF7F50",
  "#673147",
  "#722F37",
  "#A7C7E7",
  "#800000",
  "#B2BEB5",
  "#50C878",
  "#F88379",
  "#000000",
  "#F3E5AB",
  "#ADD8E6",
  "#814141",
  "#E5E4E2",
  "#228B22",
  "#FFE5B4",
  "#D8BFD8",
  "#ECFFDC",
  "#00FFFF",
  "#C2B280",
  "#71797E",
  "#B4C424",
  "#93C572",
  "#E37383",
  "#F5DEB3",
  "#6F8FAF",
];

export const borderColors = [
  "#4169E1",
  "#E1C16E",
  "#36454F",
  "#9F2B68",
  "#FFBF00",
  "#7FFFD4",
  "#CBC3E3",
  "#87CEEB",
  "#CD7F32",
  "#899499",
  "#454B1B",
  "#F2D2BD",
  "#DE3163",
  "#F5F5DC",
  "#008080",
  "#A52A2A",
  "#FFFAA0",
  "#AFE1AF",
  "#E97451",
  "#C9A9A6",
  "#A95C68",
  "#4682B4",
  "#C19A6B",
  "#8A9A5B",
  "#023020",
  "#FF7F50",
  "#673147",
  "#722F37",
  "#A7C7E7",
  "#800000",
  "#B2BEB5",
  "#50C878",
  "#F88379",
  "#000000",
  "#F3E5AB",
  "#ADD8E6",
  "#814141",
  "#E5E4E2",
  "#228B22",
  "#FFE5B4",
  "#D8BFD8",
  "#ECFFDC",
  "#00FFFF",
  "#C2B280",
  "#71797E",
  "#B4C424",
  "#93C572",
  "#E37383",
  "#F5DEB3",
  "#6F8FAF",
];

// utils/common.ts
export const backgroundColorsPieChart = [
  "#4169E1",
  "#E1C16E",
  "#36454F",
  "#9F2B68",
  "#FFBF00",
  "#7FFFD4",
  "#CBC3E3",
  "#87CEEB",
  "#CD7F32",
  "#899499",
  "#454B1B",
  "#F2D2BD",
  "#DE3163",
  "#F5F5DC",
  "#008080",
  "#A52A2A",
  "#FFFAA0",
  "#AFE1AF",
  "#E97451",
  "#C9A9A6",
  "#A95C68",
  "#4682B4",
  "#C19A6B",
  "#8A9A5B",
  "#023020",
  "#FF7F50",
  "#673147",
  "#722F37",
  "#A7C7E7",
  "#800000",
  "#B2BEB5",
  "#50C878",
  "#F88379",
  "#000000",
  "#F3E5AB",
  "#ADD8E6",
  "#814141",
  "#E5E4E2",
  "#228B22",
  "#FFE5B4",
  "#D8BFD8",
  "#ECFFDC",
  "#00FFFF",
  "#C2B280",
  "#71797E",
  "#B4C424",
  "#93C572",
  "#E37383",
  "#F5DEB3",
  "#6F8FAF",
];

export const borderColorsPieChart = [
  "#4169E1",
  "#E1C16E",
  "#36454F",
  "#9F2B68",
  "#FFBF00",
  "#7FFFD4",
  "#CBC3E3",
  "#87CEEB",
  "#CD7F32",
  "#899499",
  "#454B1B",
  "#F2D2BD",
  "#DE3163",
  "#F5F5DC",
  "#008080",
  "#A52A2A",
  "#FFFAA0",
  "#AFE1AF",
  "#E97451",
  "#C9A9A6",
  "#A95C68",
  "#4682B4",
  "#C19A6B",
  "#8A9A5B",
  "#023020",
  "#FF7F50",
  "#673147",
  "#722F37",
  "#A7C7E7",
  "#800000",
  "#B2BEB5",
  "#50C878",
  "#F88379",
  "#000000",
  "#F3E5AB",
  "#ADD8E6",
  "#814141",
  "#E5E4E2",
  "#228B22",
  "#FFE5B4",
  "#D8BFD8",
  "#ECFFDC",
  "#00FFFF",
  "#C2B280",
  "#71797E",
  "#B4C424",
  "#93C572",
  "#E37383",
  "#F5DEB3",
  "#6F8FAF",
];

export const formatDateCommon = (date: any, displayDash = false) => {
  const originalDate = new Date(date);
  const day = originalDate.getDate().toString().padStart(2, "0");
  const month = (originalDate.getMonth() + 1).toString().padStart(2, "0");
  const year = originalDate.getFullYear().toString();
  return `${day}/${month}/${year}`;
};

export const createExcelFile = (data: any, fileName: string) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, fileName + ".xlsx");
};

export const hhmmToSeconds = (timeString: string) => {
  const [hours, minutes] = (timeString ?? "").split(":")?.map(Number) || ["", ""];
  return hours * 3600 + minutes * 60;
};

export const convertUTCToLocalTimeDate = (utcString:string) => {
  const utcDate = new Date(utcString);
  return new Date(
    utcDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }) 
  );
};

export const useGetFetchQuery = (name: any) => {
  const queryClient = useQueryClient();

  return queryClient.getQueryData(name);
};

export const fetchQuestionCategories = async (
  organizationId: number 
): Promise<Option[]> => {
 
  const response: any = await axiosPost(getAllQuestionCategory, {
    SearchText: "",
    IsActive: true,
    CurrentPageNo: 1,
    PageSize: 0,
    SortDir: "DESC",
    SortBy: "QuestionCategoryId",
    OrganizationId: organizationId,
  });
  const data = response.data.ExtraData || [];
  return data?.map((item: any) => ({
    label: item.QuestionCategoryName,
    value: item.QuestionCategoryId,
  }));
};


export const useFetchQuestionCategories = (organizationId: number) => {
  return useQuery(
    ["questioncategory", organizationId],
    () => fetchQuestionCategories(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching questioncategory", ToastTypeCode?.ERROR);
      },
    }
  );
};

export const fetchOrganizations = async (): Promise<Option[]> => {
  const response: any = await axiosPost(getAllOrganizations, {
    SearchText: "",
    IsActive: true,
    CurrentPageNo: 1,
    PageSize: 0,
    SortDir: "DESC",
    SortBy: "OrganizationId",
  });

  if (response?.data?.Status === 200) {
    return (
      response?.data?.ExtraData?.map((item: any) => ({
        label: item?.OrganizationName,
        value: item?.OrganizationId,
      })) || []
    );
  } else {
    throw new Error("Error fetching organizations");
  }
};

export const convertToIST = (utcDateString: string): string => {
  if (!utcDateString) return "Invalid Date";
  const utcDate = new Date(utcDateString);
  return utcDate.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
};

export const useOrganizations = () => {
  return useQuery({
    queryKey: ["organizations"],
    queryFn: fetchOrganizations,
    onError: () => {
      showToast("Error fetching organizations", ToastTypeCode?.ERROR);
    },
  });
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
    },
  },
});

export const getCachedData = async (key: any) => {
  let data = queryClient.getQueryData(key);

  if (!data && key === "organizations") {
    // Fetch the data if it's not cached
    data = await queryClient.fetchQuery({
      queryKey: ["organizations"],
      queryFn: fetchOrganizations,
    });
  }
  return data || [];
};

const fetchDepartments = async (organizationId: number): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllUserDepartments, {
      SearchText: "",
      IsActive: 1,
      OrganizationId: organizationId || -1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId", // Adjust this if sorting should be done differently
    });

    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.DepartmentName, // Ensure this maps to the correct property
          value: item?.DepartmentId, // Ensure this maps to the correct property
        })) || []
      );
    } else {
      showToast("Error fetching departments", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching departments", ToastTypeCode?.ERROR);
    return [];
  }
};

// Usage with React Query
export const useFetchDepartments = (organizationId: number) => {
  return useQuery(
    ["department", organizationId],
    () => fetchDepartments(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching departments", ToastTypeCode?.ERROR);
      },
    }
  );
};

const fetchDesignation = async (organizationId: number): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllUserDesignations, {
      SearchText: "",
      IsActive: 1,
      OrganizationId: organizationId ? organizationId : -1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId",
    });
    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.DesignationName, 
          value: item?.DesignationId, 
        })) || []
      );
    } else {
      showToast("Error fetching Designation", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching Designation", ToastTypeCode?.ERROR);
    return [];
  }
};

export const useFetchDesignation = (organizationId: number ) => {
  return useQuery(
    ["designation", organizationId],
    () => fetchDesignation(organizationId),
    {
      enabled: !!organizationId, 
      onError: () => {
        showToast("Error fetching designations", ToastTypeCode?.ERROR);
      },
    }
  );
};

const fetchClassification = async (organizationId: number ): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllUserClassifications, {
      SearchText: "",
      IsActive: 1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId",
      OrganizationId: organizationId ? organizationId : -1,
    });
    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.ClassificationName, 
          value: item?.ClassificationID, 
        })) || []
      );} else {
      showToast("Error fetching Classification", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching Classification", ToastTypeCode?.ERROR);
    return [];
  }
};

export const useFetchClassification = (organizationId: number ) => {
  return useQuery(
    ["classification", organizationId],
    () => fetchClassification(organizationId),
    {
      enabled: !!organizationId, 
      onError: () => {
        showToast("Error fetching classifications", ToastTypeCode?.ERROR);
      },
    }
  );
};

const fetchLocation = async (organizationId: number ): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllLocations, {
      SearchText: "",
      IsActive: 1,
      OrganizationId: organizationId ? organizationId : -1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId",
    });
    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.LocationName, 
          value: item?.LocationId, 
        })) || []
      );} else {
      showToast("Error fetching Location", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching Location", ToastTypeCode?.ERROR);
    return [];
  }
};


export const useFetchLocation = (organizationId: number ) => {
  return useQuery(
    ["location", organizationId],
    () => fetchLocation(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching classifications", ToastTypeCode?.ERROR);
      },
    }
  );
};


const fetchResponseTypes = async (): Promise<Option[]> => {
  const response: any = await axiosPost(getAllResponseTypes, {
    SearchText: "",
    IsActive: true,
    CurrentPageNo: 1,
    PageSize: 0,
    SortDir: "ASC",
    SortBy: "ResponseTypeId",
  });
  const data = response?.data?.ExtraData || [];
  return data?.map((item: any) => ({
    label: item.ResponseTypeName,
    value: item.ResponseTypeId,
  }));
};



export const useFetchResponseTypes = () => {
  return useQuery(
    "responseTypes", 
    fetchResponseTypes, 
    {
      onError: () => {
        showToast("Error fetching response types", ToastTypeCode?.ERROR);
      },
    }
  );
};


export const viewOptionsList = [
  { label: "Percentage", value: 1 },
  { label: "Count", value: 2 },
];


export type TemplateOption = {
  TemplateQuestionOptionId: number;
  ResponseTypeId: number;
  ResponseTypeName: string;
  OptionTitle: string;
  IsActive: boolean;
  IsCorrect: boolean | null;
};

export type TemplateQuestion = {
  TemplateQuestionId: number;
  QuestionTitle: string;
  Instruction: string;
  IsActive: boolean;
  IsRequired: boolean;
  Options: TemplateOption[];
};

export type TemplateCategory = {
  TemplateCategoryId: number;
  CategoryName: string;
  CategoryDescription: string;
  TemplateSubcategoryId: number;
  SubcategoryName: string;
  SubcategoryDescription: string;
  Questions: TemplateQuestion[];
};